import { DeskingConfigurationBaseOnAccount } from '../types';

export const PAYLINK_DEV_ACCOUNT_ID = 'e610bb84-6805-11f0-9b79-fbfe5bc04809';
export const PAYLINK_PROD_ACCOUNT_ID = 'e6288ba6-6805-11f0-b687-47fa3e965252';

const NTP_PROD_ACCOUNT_ID = 'af389c24-71db-11ef-b67d-438054f5b5e6';
const NTP_DEV_ACCOUNT_ID = 'aebc4dfe-71db-11ef-a943-db9302946276';

const NTP_CONFIG: Partial<DeskingConfigurationBaseOnAccount> = {
  formFieldsRequire: {
    'equipment.mileage': {
      value: true,
      message: 'Required field',
    },
    'equipment.serialNumberVin': {
      value: true,
      message: 'Required field',
    },
  },
  displaySettings: {
    excludeEquipmentSales: true,
    shouldRedirectToOCA: false,
  },
  notifications: {
    menuBuilder: 'Serial/VIN#, Mileage require fields for interaction with products',
  },
};

export const deskingConfigByAccId: Record<string, Partial<DeskingConfigurationBaseOnAccount>> = {
  [NTP_DEV_ACCOUNT_ID]: NTP_CONFIG,
  [NTP_PROD_ACCOUNT_ID]: NTP_CONFIG,
};
